/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Premium_SpeedInputs */

const en_dialog_premium_speed = /** @type {(inputs: Dialog_Premium_SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listen up to 4x with Listening Premium`)
};

const es_dialog_premium_speed = /** @type {(inputs: Dialog_Premium_SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escucha hasta 4x con Listening Premium`)
};

/**
* | output |
* | --- |
* | "Listen up to 4x with Listening Premium" |
*
* @param {Dialog_Premium_SpeedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_premium_speed = /** @type {((inputs?: Dialog_Premium_SpeedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Premium_SpeedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_premium_speed(inputs)
	return en_dialog_premium_speed(inputs)
});